import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgChartsModule } from "ng2-charts";
import { routes } from "src/app/app.router";
import { SharedModule } from "src/app/shared/shared.module";
import { UserSearchComponent } from "./users/user-search/user-search.component";
import { UserCreateOrUpdateComponent } from "./users/user-create-or-update/user-create-or-update.component";
import { UserMangementMenuComponent } from "./menu/user-mangement-menu/user-mangement-menu.component";
import { DeleteDialogComponent } from "./shared/dialogs/delete-dialog/delete-dialog.component";
import { SuccessDialogComponent } from "./shared/dialogs/success-dialog/success-dialog.component";
import { RoleSearchComponent } from './roles/role-search/role-search.component';


@NgModule({
  declarations: [
    UserSearchComponent,
    UserCreateOrUpdateComponent,
    UserMangementMenuComponent,
    DeleteDialogComponent,
    SuccessDialogComponent,
    RoleSearchComponent
  ],
  imports: [
        routes,
        CommonModule,
        RouterModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        MatTooltipModule,
        NgbModule,
        NgChartsModule  
  ],
  exports: [
    UserMangementMenuComponent,
    DeleteDialogComponent,
    SuccessDialogComponent,
    UserSearchComponent,
    UserCreateOrUpdateComponent,
    RoleSearchComponent
  ]
})
export class UserManagementModule { }